module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-brands-400.svg?928495fae14841a0d61062ba4926be1d";